import React from 'react';
import {useNavigate} from 'react-router-dom';

import Button from '@pb/kit-component-button';
import Group from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';
import Typography from '@pb/kit-component-typography';

import {description, setupCompleteContainer, successIcon} from './setup-complete.module.styl';

export const SetupComplete: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Group direction="v" alignItems="center" className={setupCompleteContainer}>
            <div className={successIcon}>
                <Icon type={Icons.CHECK} size="Size_32"/>
            </div>

            <Typography variant="heading-level-1">
                SSO Setup Complete
            </Typography>

            <span className={description}>
                Your Single Sign-On configuration has been saved successfully.
                Your team can now sign in to PitchBook using your company&apos;s login system.
            </span>

            <Button variant="Type.PRIMARY" onClick={() => navigate('/')}>
                View Configuration Summary
            </Button>
        </Group>
    );
};
